//
import { List, Record } from 'immutable';

export const mkFormDialogProps = Record({
  title: 'Alert',
  content: '',
  label: '',
  isPassword: false,
  buttons: List(['Yes', 'No']),
  onClose: null,
});

export const DIALOG_TYPE = 'DIALOG_FORM';
